import { render, staticRenderFns } from "./tow-drivers.vue?vue&type=template&id=128f6e8e"
import script from "./tow-drivers.vue?vue&type=script&lang=js"
export * from "./tow-drivers.vue?vue&type=script&lang=js"
import style0 from "./tow-drivers.vue?vue&type=style&index=0&id=128f6e8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports